import React from "react";
import PropTypes from 'prop-types';
import { DivInput } from "../atoms/DivInput";
import {isNullOrUndefinded} from "../../helper/utils";

const InputCheckBox = ({
  label,
  textInput = "No / Sí",
  name,
  value,
  onChange,
  sectionName,
  isDisabled,
  isRequired,
  additionalLabel = null,
  colLabel=4,
  colInput=8,
  direction = "row",
  additionalClass = "",
  inputCheckBoxClass = "custom-switch mt-1 ml-3",
  hasValidationMessage = true,
    id
}) => {
  return (
    <DivInput direction={direction} colLabel={colLabel} colInput={colInput} className={additionalClass}>
      {label &&
          <label className={`modal-label ${isRequired ? "required" : ""}`}>
            {label} {additionalLabel && additionalLabel()}
          </label>
      }

      <div className="black-color">
          <div className="d-flex align-items-center h-100">
          <input
            type="checkbox"
            name={name}
            onChange={onChange}
            checked={value ?? false}
            value={value ?? false}
            disabled={isDisabled}
            id={ isNullOrUndefinded(id) ? `admin-input-bool-select-${sectionName}-${name}` : id}
            className={""}
          ></input>
        </div>
      </div>
    </DivInput>
  );
};

export default InputCheckBox;